import { z } from "zod";
import { isPasswordStrengthBlocked } from "@/lib/password-strength";

const personNameSchema = z
  .string()
  .trim()
  .min(2, "Required field or minimum 2 characters")
  .max(100, "Must be 100 characters or less");

export const profileFormSchema = z.object({
  firstName: personNameSchema,
  lastName: personNameSchema,
});

export type ProfileFormValues = z.infer<typeof profileFormSchema>;

export const passwordFormSchema = z
  .object({
    currentPassword: z.string().min(1, "Enter your current password"),
    newPassword: z.string().min(8, "Password must be at least 8 characters"),
    confirmPassword: z.string().min(1, "Confirm your password"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  })
  .refine((data) => !isPasswordStrengthBlocked(data.newPassword), {
    message: "Password is too weak — add numbers or special characters",
    path: ["newPassword"],
  });

export type PasswordFormValues = z.infer<typeof passwordFormSchema>;
